import { Editor } from "@tiptap/react";
import React, { FC } from "react";
import { IconType } from "react-icons/lib/iconBase";
import { LuUndo as UndoIcon } from "react-icons/lu";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { SVGReactComponent } from "src/@types";

interface Props {
  editor: Editor;
  icon?: IconType | SVGReactComponent;
}
export const UndoButton: FC<Props> = ({ editor, icon: Icon = UndoIcon }) => {
  const onClick = () => editor.chain().focus().undo().run();
  return (
    <Button
      type="button"
      variant={ButtonVariants.SECONDARY}
      className="!rounded-md !duration-100 !p-1"
      onClick={onClick}
    >
      <Icon title="undo" className="w-5 h-5 text-black-base" />
    </Button>
  );
};
